/* eslint-disable array-callback-return */
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { PageHeader } from '../../components/';
import { BASE_URL } from '../../constants/api-urls';
import {
  SPOTIFY_CODE,
  SPOTIFY_REFRESH_TOKEN,
  SPOTIFY_TOKEN,
  SPOTIFY_USER_INFO,
} from '../../constants/storage';
import { useLoginContext } from '../../context';
import { usePackageContext } from '../../context/PackageContext';
import { Auth0Logout, addItemToStorage, deleteItemFromStorage, getstripePrices } from '../../utils';
import {
  getPostPlanRedirectPath,
  normalizeOnboardingIntent,
  requiresCampaignsOnboarding,
} from '../../utils/onboardingIntent';
import { LoginStyle } from '../Login/Login.style';
import { LoaderPageStyle } from '../Login/ShiftPage.style';
import { getCuratorAuthHeader } from '../../utils/curatorApiAuth';

const SignupCallback = () => {
  const [searchParams] = useSearchParams();
  const session_id = searchParams.get('session_id');

  const { dispatch } = useLoginContext();
  const { clearCache } = usePackageContext();

  const [showmessage, setShowMessage] = useState('loading');

  let proPlanMonthly = process.env.REACT_APP_STRIPE_PRO_MONTHLY;
  let proPlan = process.env.REACT_APP_STRIPE_PRO;
  let unlimitedPlanMonthly = process.env.REACT_APP_STRIPE_UNLIMITED_MONTHLY;
  let unlimitedPlan = process.env.REACT_APP_STRIPE_UNLIMITED;

  let STRIPE_PRO_MONTHLY = process.env.REACT_APP_STRIPE_PRO_MONTHLY;
  let STRIPE_PRO = process.env.REACT_APP_STRIPE_PRO;
  let STRIPE_UNLIMITED_MONTHLY = process.env.REACT_APP_STRIPE_UNLIMITED_MONTHLY;
  let STRIPE_UNLIMITED = process.env.REACT_APP_STRIPE_UNLIMITED;

  useEffect(() => {
    (async () => {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || 'null');
      if (!userInfo?.userId && !userInfo?.token) {
        setShowMessage('expire');
        return;
      }

      let prices = await getstripePrices();
      let proPlans = prices.data.data.filter(
        obj => obj.id === STRIPE_PRO || obj.id === STRIPE_PRO_MONTHLY
      );
      let unlimitedPlans = prices.data.data.filter(
        obj => obj.id === STRIPE_UNLIMITED_MONTHLY || obj.id === STRIPE_UNLIMITED
      );

      const proMonthly = proPlans.find(obj => obj.id === STRIPE_PRO_MONTHLY);
      const proYearly = proPlans.find(obj => obj.id === STRIPE_PRO);
      const unlimitedMonthly = unlimitedPlans.find(obj => obj.id === STRIPE_UNLIMITED_MONTHLY);
      const unlimitedYearly = unlimitedPlans.find(obj => obj.id === STRIPE_UNLIMITED);
      if (!proMonthly || !proYearly || !unlimitedMonthly || !unlimitedYearly) {
        console.error('SignupCallback: missing Stripe price(s) in getPrices response', {
          STRIPE_PRO_MONTHLY,
          STRIPE_PRO,
          STRIPE_UNLIMITED_MONTHLY,
          STRIPE_UNLIMITED,
        });
        toast.error('Network error');
        setShowMessage('expire');
        return;
      }

      let monthly_pro_price = Object.values(
        proMonthly.currency_options
        // @ts-ignore
      ).map(obj => obj.unit_amount);
      let annually_pro_price = Object.values(
        proYearly.currency_options
        // @ts-ignore
      ).map(obj => obj.unit_amount);
      let monthly_unlimited_price = Object.values(
        unlimitedMonthly.currency_options
        // @ts-ignore
      ).map(obj => obj.unit_amount);
      let annually_unlimited_price = Object.values(
        unlimitedYearly.currency_options
        // @ts-ignore
      ).map(obj => obj.unit_amount);
      const continueAfterUser = (respo: { sub: string; email?: string; picture?: string }) => {
        axios
          .get(`${BASE_URL}/auth0/user/${respo.sub}/profile`)
          .then(profileResponse => profileResponse.data.data)
          // Profile is only used for the subscription id; completion must not depend on it.
          .catch(() => ({}))
          .then(res2 => {
            let subId = res2?.user_metadata?.subscription;
            fetch(`${BASE_URL}/packages/completed`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                ...getCuratorAuthHeader(),
              },
              body: JSON.stringify({
                sessionId: `${session_id}`,
                subId,
              }),
            })
              .then(res => res.json())
              .then(responesee => {
                const metadataProductId = responesee?.data?.metadata?.product_id;

                const resolvedPlanId = metadataProductId
                  ? metadataProductId
                  : monthly_pro_price.includes(Number(responesee.data.amount_subtotal))
                    ? proPlanMonthly
                    : annually_pro_price.includes(Number(responesee.data.amount_subtotal))
                      ? proPlan
                      : monthly_unlimited_price.includes(
                            Number(responesee.data.amount_subtotal)
                          )
                        ? unlimitedPlanMonthly
                        : annually_unlimited_price.includes(
                              Number(responesee.data.amount_subtotal)
                            )
                          ? unlimitedPlan
                          : '';

                const resolvedDuration = metadataProductId
                  ? resolvedPlanId === proPlanMonthly || resolvedPlanId === unlimitedPlanMonthly
                    ? 'month'
                    : 'year'
                  : monthly_pro_price.includes(Number(responesee.data.amount_subtotal)) ||
                      monthly_unlimited_price.includes(Number(responesee.data.amount_subtotal))
                    ? 'month'
                    : annually_pro_price.includes(Number(responesee.data.amount_subtotal)) ||
                        annually_unlimited_price.includes(
                          Number(responesee.data.amount_subtotal)
                        )
                      ? 'year'
                      : '';

                let updatedUser = {
                  ...userInfo,

                  subId: session_id === 'free' ? '' : responesee.data.subscription,
                  amount_subtotal: responesee.data.amount_subtotal,
                  planId: session_id === 'free' ? 'free' : resolvedPlanId,
                  free: session_id === 'free' ? true : false,
                  duration: session_id === 'free' ? '' : resolvedDuration,
                };
                localStorage.setItem('userInfo', JSON.stringify(updatedUser));
                try {
                  // Re-read latest storage (do not trust the stale userInfo captured at effect start).
                  // URL ?intent= is a backup for Option A free path if storage was incomplete.
                  let latestUserInfo: Record<string, any> = {};
                  try {
                    latestUserInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
                  } catch {
                    latestUserInfo = userInfo || {};
                  }
                  const intentFromQuery = normalizeOnboardingIntent(
                    searchParams.get('intent')
                  );
                  const existingIntent = normalizeOnboardingIntent(
                    latestUserInfo?.onboardingIntent ||
                      userInfo?.onboardingIntent ||
                      intentFromQuery
                  );

                  // Completed only when flag is explicitly false (offer finished).
                  // Missing/true + intent A/C → still required (first-time A/C).
                  // Never re-force after explicit false on paid upgrade /created.
                  let campaignsRequired = requiresCampaignsOnboarding(
                    existingIntent,
                    latestUserInfo?.campaignsOnboardingRequired
                  );
                  // Free A/C first completion always forces campaigns onboarding.
                  // intent query is only added from first-time free paths (not upgrades).
                  if (
                    session_id === 'free' &&
                    (intentFromQuery === 'submissions' || intentFromQuery === 'both')
                  ) {
                    campaignsRequired = true;
                  }

                  // Prepare metadata for backend API
                  const metadataPayload: Record<string, any> = {
                    onBoarding: true,
                    payment: responesee?.free
                      ? null
                      : `${responesee?.data?.payment_intent}`,
                    subscription: responesee?.free
                      ? null
                      : `${
                          typeof responesee?.data?.subscription === 'string'
                            ? responesee?.data?.subscription
                            : responesee?.data?.subscription?.id
                        }`,
                    customer: responesee?.free
                      ? null
                      : `${
                          typeof responesee?.data?.customer === 'string'
                            ? responesee?.data?.customer
                            : responesee?.data?.customer?.id
                        }`,
                    free: responesee?.free,
                  };

                  // Do not send onboardingIntent here (immutable; may already be set).
                  // Only set required=true when still incomplete. Never rewrite true after completion.
                  // Never PATCH false from this page (would poison first-time A/C).
                  if (campaignsRequired) {
                    metadataPayload.campaignsOnboardingRequired = true;
                  }

                  // Update metadata via backend API (instead of direct Auth0 call)
                  axios
                    .patch(`${BASE_URL}/auth0/user/${respo?.sub}/metadata`, metadataPayload)
                    .then(response => {
                      // Update localStorage userInfo with new customer and subscription data
                      try {
                        const currentUserInfo = JSON.parse(
                          localStorage.getItem('userInfo') || '{}'
                        );

                        // Handle different customer/subscription data formats
                        const customerId = responesee?.free
                          ? null
                          : typeof responesee?.data?.customer === 'string'
                            ? responesee?.data?.customer
                            : responesee?.data?.customer?.id;

                        const subscriptionId = responesee?.free
                          ? null
                          : typeof responesee?.data?.subscription === 'string'
                            ? responesee?.data?.subscription
                            : responesee?.data?.subscription?.id;

                        const updatedUserInfo: Record<string, any> = {
                          ...currentUserInfo,
                          custId: customerId,
                          subId: subscriptionId,
                          customer: customerId,
                          subscription: subscriptionId,
                          payment: responesee?.free
                            ? null
                            : responesee?.data?.payment_intent,
                          free: responesee?.free,
                          onboardingIntent:
                            existingIntent || currentUserInfo?.onboardingIntent || null,
                        };
                        // Only persist true when still required. Do not write false here
                        // (false is reserved for campaigns-onboarding/complete after offer).
                        if (campaignsRequired) {
                          updatedUserInfo.campaignsOnboardingRequired = true;
                        } else if (currentUserInfo?.campaignsOnboardingRequired === false) {
                          updatedUserInfo.campaignsOnboardingRequired = false;
                        }
                        localStorage.setItem('userInfo', JSON.stringify(updatedUserInfo));
                      } catch (err) {
                        console.error('❌ Failed to update localStorage userInfo:', err);
                      }

                      const postPlanPath = getPostPlanRedirectPath(
                        existingIntent,
                        campaignsRequired
                      );

                      const config = {
                        headers: {
                          'Content-Type': 'application-json',
                        },
                      };
                      axios
                        .get(`${BASE_URL}/user/${respo?.sub}/data`, config)
                        .then(call => {
                          // Check if Spotify is already connected (for returning users)
                          const hasSpotifyConnection = call?.data?.data?.length > 0;

                          if (hasSpotifyConnection) {
                            // User already has Spotify connected - load their data
                            call?.data?.data &&
                              call?.data?.data?.length > 0 &&
                              call?.data?.data
                                .reverse()
                                .slice(-1)
                                .map((_a, indexes) => {
                                  const data = {
                                    username: _a?.username,
                                    image:
                                      _a?.image !== undefined
                                        ? _a?.image[0]?.url
                                          ? _a?.image[0]?.url
                                          : 'dummy'
                                        : 'dummy',
                                    code: _a?.code,
                                    refresh: _a?.refresh_token,
                                  };
                                  localStorage.setItem(
                                    'spotifyUser',
                                    JSON.stringify(data, null, ' ')
                                  );
                                  addItemToStorage(SPOTIFY_TOKEN, _a?.token);
                                  addItemToStorage(SPOTIFY_REFRESH_TOKEN, _a?.refresh);
                                  addItemToStorage(SPOTIFY_CODE, _a?.code);

                                  dispatch({
                                    type: 'ADD_APP_TOKEN',
                                    payload: {
                                      token: _a?.token,
                                      refreshToken: _a?.refresh,
                                    },
                                  });
                                });
                          }

                          // Store Spotify connection status in localStorage
                          localStorage.setItem(
                            'hasSpotifyConnection',
                            String(hasSpotifyConnection)
                          );

                          // tools → /home; submissions/both → /campaigns?onboarding=1; legacy → /home
                          setTimeout(() => {
                            window.location.replace(postPlanPath);
                          }, 1500);
                        })
                        .catch(err => {
                          // Even on error, allow user to proceed (correct path by intent)
                          localStorage.setItem('hasSpotifyConnection', 'false');
                          setTimeout(() => {
                            window.location.replace(postPlanPath);
                          }, 1500);
                        });
                    })
                    .catch(err => {
                      toast.error(err);
                      setShowMessage('expire');
                    });
                } catch (err) {
                  toast.error('Network error');
                  setShowMessage('expire');
                }
              })
              .catch(error => {
                toast.error('Network error');
                setShowMessage('expire');
              });
          });
      };

      axios
        .post(`${BASE_URL}/auth0/userinfo`, {
          access_token: userInfo?.token,
        })
        .then(userInfoResponse => {
          const respo = userInfoResponse.data?.data;
          if (!respo?.sub) {
            throw new Error('missing_sub');
          }
          continueAfterUser(respo);
        })
        .catch(() => {
          if (userInfo?.userId) {
            continueAfterUser({
              sub: userInfo.userId,
              email: userInfo.email,
              picture: userInfo.profileImage,
            });
            return;
          }
          toast.error('Network error');
          setShowMessage('expire');
        });
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [STRIPE_PRO_MONTHLY, STRIPE_PRO, STRIPE_UNLIMITED_MONTHLY, STRIPE_UNLIMITED]);

  const onBack = () => {
    deleteItemFromStorage(SPOTIFY_TOKEN);
    deleteItemFromStorage(SPOTIFY_CODE);
    deleteItemFromStorage(SPOTIFY_USER_INFO);
    localStorage.removeItem('userInfo');
    localStorage.removeItem('spotifyUser');

    // Clear package cache
    clearCache();

    Auth0Logout();
  };

  return (
    <>
      <PageHeader
        title="Songplace - The best platform to manage your Spotify playlists"
        description="The best platform to manage your Spotify playlists."
        image="./static/mini-logo.png"
      />
      {showmessage === 'expire' ? (
        <LoginStyle>
          <div className="background-col-1">
            <div className="background">
              <div className="expire-div">
                <img src="./static/images/undraw_completing_re_i7ap.png" alt="Payment successful" />
              </div>
              <h3 style={{}} className="h3">
                Payment successful
              </h3>
              <p className="ppp">Please relogin to continue</p>
              <div className="dives">
                <button onClick={onBack} className="btn1">
                  Logout
                </button>
              </div>
            </div>
          </div>
        </LoginStyle>
      ) : (
        <LoaderPageStyle>
          <div className="loadingPage">
            <h1>Taking you to Songplace</h1>
            <div className="loadingDiv">
              <div className="loadingCircle"></div>
            </div>
          </div>
        </LoaderPageStyle>
      )}
    </>
  );
};

export default SignupCallback;
